import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import vuetify from './plugins/vuetify';
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import ScrollAnimation from './directives/scrollanimation';
import Nl2br from 'vue-nl2br'

Vue.component('nl2br', Nl2br)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.directive('scrollanimation', ScrollAnimation);
Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
